"use client";

import * as React from "react";
import { Clock, CirclePlay as PlayCircle, Radio, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function LiveUpdatesConsumer() {
  const {
    posts,
    loading
  } = usePosts();
  if (loading) {
    return <div className="flex flex-col gap-8 p-6">
        {[...Array(3)].map((_, i) => <div key={i} className="flex flex-col gap-2 animate-pulse">
            <div className="h-4 w-20 bg-muted rounded" />
            <div className="h-4 w-full bg-muted rounded" />
          </div>)}
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="p-6 text-center text-muted-foreground text-sm">
        Tidak ada pembaruan saat ini.
      </div>;
  }
  return <ScrollArea className="h-[350px] md:h-[450px] lg:h-[550px] w-full p-6">
      <div className="relative">
        {posts.map((post, i) => <div data-index={i} key={post.id} className="relative pl-8 pb-8 last:pb-0 group">
            {}
            {i !== posts.length - 1 && <div className="absolute left-[11px] top-6 bottom-0 w-px bg-border group-hover:bg-primary/30 transition-colors duration-300" />}
            
            {}
            <div className="absolute left-0 top-1.5 size-6 rounded-lg bg-background border-2 border-muted-foreground/30 flex items-center justify-center z-10 group-hover:border-primary transition-colors duration-300">
              <div className="size-2 rounded-lg bg-muted-foreground/30 group-hover:bg-primary transition-colors duration-300" />
            </div>
            
            {}
            <div className="flex flex-col gap-2">
              <span className="text-xs font-semibold text-primary flex items-center gap-1.5 bg-primary/10 w-fit px-2 py-0.5 rounded-md">
                {post.date ? new Date(post.date).toLocaleTimeString('id-ID', {
              hour: '2-digit',
              minute: '2-digit'
            }) + ' WIB' : 'Baru saja'}
              </span>
              <div className="text-sm leading-relaxed text-foreground/90">
                <h4 className="font-medium mb-1">{post.title}</h4>
                <div dangerouslySetInnerHTML={{
              __html: post.excerpt || ""
            }} className="line-clamp-3" />
              </div>
            </div>
          </div>)}
      </div>
    </ScrollArea>;
}
export default function LiveUpdateCepat() {
  const wp_query_params = {
    post_type: 'post',
    per_page: 5,
    status: ['publish'],
    order: 'desc',
    orderby: 'date'
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="live-update-cepat" className="py-12 md:py-16 lg:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-start">
          
          {}
          <div className="md:col-span-12 lg:col-span-5 xl:col-span-4 flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight">Liputan Langsung</h2>
              <p className="text-sm md:text-base text-muted-foreground">
                Pantau perkembangan acara secara real-time dari lokasi utama.
              </p>
            </div>

            <Card className="overflow-hidden border-border/50 shadow-sm">
              <CardHeader className="bg-muted/30 p-4 md:p-6 pb-4 md:pb-4 border-b border-border/50">
                <div className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2 text-lg">
                    <Radio className="size-5 text-destructive" />
                    Siaran Utama
                  </CardTitle>
                  <span className="flex items-center gap-1.5 rounded-lg bg-destructive/10 px-2.5 py-1 text-xs font-medium text-destructive">
                    <span className="relative flex size-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-destructive opacity-75"></span>
                      <span className="relative inline-flex rounded-lg size-2 bg-destructive"></span>
                    </span>
                    LIVE
                  </span>
                </div>
              </CardHeader>
              <CardContent className="p-0">
                <div className="relative aspect-video max-h-[250px] md:max-h-[400px] lg:max-h-none bg-muted flex items-center justify-center group cursor-pointer overflow-hidden">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_live_event_crowd.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_live_event_crowd.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_live_event_crowd.png-wvc-sizes" alt="Live Event Stream" className="absolute inset-0 w-full h-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-300" />
                  <div className="relative z-10 size-16 rounded-lg bg-background/90 flex items-center justify-center shadow-lg backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
                    <PlayCircle className="size-8 text-primary ml-1" />
                  </div>
                  
                  <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-md text-white text-xs px-2 py-1 rounded-md flex items-center gap-1.5">
                     <span className="size-1.5 rounded-lg bg-destructive"></span>
                     1,245 Menonton
                  </div>
                </div>
              </CardContent>
              <CardFooter className="p-4 md:p-6 bg-muted/10 flex flex-col items-start gap-2">
                <h3 className="font-semibold text-sm md:text-base">Sesi Pembukaan & Sambutan</h3>
                <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                  Saksikan langsung pembukaan acara resmi yang dihadiri oleh para delegasi dan tamu kehormatan dari berbagai instansi.
                </p>
              </CardFooter>
            </Card>
          </div>

          {}
          <div className="md:col-span-12 lg:col-span-7 xl:col-span-8">
            <Card className="h-full border-border/50 shadow-sm flex flex-col">
              <CardHeader className="flex flex-row items-center justify-between border-b border-border/50 p-4 md:p-6 pb-4 md:pb-4">
                <div className="space-y-1">
                  <CardTitle className="text-lg md:text-xl flex items-center gap-2">
                    <Clock className="size-5 text-primary" />
                    Update Cepat
                  </CardTitle>
                  <CardDescription className="text-xs md:text-sm">
                    Informasi terkini langsung dari lapangan.
                  </CardDescription>
                </div>
                <Button variant="ghost" size="sm" asChild className="hidden sm:flex">
                  <Link to="/NewsPage">
                    Lihat Semua <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </CardHeader>
              <CardContent className="p-0 flex-1">
                <PostsProvider wp_query={{
                post_type: "post",
                per_page: 5,
                status: ["publish"],
                order: "desc",
                orderby: "date"
              }}>
                  <LiveUpdatesConsumer />
                </PostsProvider>
              </CardContent>
              <CardFooter className="p-4 md:p-6 border-t border-border/50 sm:hidden">
                 <Button variant="outline" className="w-full" asChild>
                  <Link to="/NewsPage">
                    Lihat Semua Update
                  </Link>
                </Button>
              </CardFooter>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}